import React from "react";
import Cookies from 'js-cookie';
import { getLanguageSection } from '../../../shared/services/languageService';

function getCurrentYear() {
  return new Date().getFullYear();
}

function IconFacebook() {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" className="h-5 w-5" aria-hidden="true">
      <path d="M13.5 21v-8h2.7l.4-3.1h-3.1V7.9c0-.9.25-1.5 1.55-1.5H17V3.6c-.3 0-1.3-.1-2.45-.1-2.43 0-4.05 1.48-4.05 4.2v2.2H7.7V13h2.8v8h3Z" />
    </svg>
  );
}

function IconInstagram() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" className="h-5 w-5" aria-hidden="true">
      <rect x="3.5" y="3.5" width="17" height="17" rx="4.6" />
      <circle cx="12" cy="12" r="3.6" />
      <circle cx="17.2" cy="6.8" r="1" fill="currentColor" stroke="none" />
    </svg>
  );
}

function IconTiktok() {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" className="h-5 w-5" aria-hidden="true">
      <path d="M16.5 3c.4 2.1 1.7 3.6 3.8 3.9v2.6c-1.3.1-2.5-.3-3.8-1v5.9c0 3.4-2.5 5.6-5.6 5.6-2.9 0-5.2-2.1-5.2-4.9 0-3 2.4-5 5.4-4.8v2.7c-.4-.1-.8-.2-1.2-.1-1.2.1-2 .9-1.9 2.1.1 1.2 1 2 2.2 1.9 1.3-.1 2-1 2-2.4V3h3.9Z" />
    </svg>
  );
}

function IconYoutube() {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" className="h-5 w-5" aria-hidden="true">
      <path d="M22 12s0-3.3-.4-4.8c-.2-.8-.9-1.5-1.7-1.7C18.3 5 12 5 12 5s-6.3 0-7.9.5c-.8.2-1.5.9-1.7 1.7C2 8.7 2 12 2 12s0 3.3.4 4.8c.2.8.9 1.5 1.7 1.7C5.7 19 12 19 12 19s6.3 0 7.9-.5c.8-.2 1.5-.9 1.7-1.7.4-1.5.4-4.8.4-4.8ZM10 15V9l5 3-5 3Z" />
    </svg>
  );
}

function Footer() {
  const language = getLanguageSection('footer');
  const currentYear = getCurrentYear();
  const isSpanish = Cookies.get('language') === 'esp';

  const privacyHref = isSpanish ? '/es/aviso-de-privacidad' : '/privacy-notice';
  const cookieHref = isSpanish ? '/es/politica-de-cookies' : '/cookie-policy';

  const socials = [
    { label: 'Facebook', href: 'https://www.facebook.com/MarivalResortsOficial/', icon: <IconFacebook /> },
    { label: 'Instagram', href: 'https://www.instagram.com/marivalresorts/', icon: <IconInstagram /> },
    { label: 'TikTok', href: 'https://www.tiktok.com/@marivalresorts', icon: <IconTiktok /> },
    { label: 'YouTube', href: 'https://www.youtube.com/user/marivalchannel', icon: <IconYoutube /> }
  ];

  return (
    <footer className="mr-ui bg-[#171d54] text-white">
      <div className="mx-auto w-full max-w-7xl px-5 py-9 md:px-8">
        {/* Redes sociales */}
        <div className="flex flex-col items-center gap-4">
          <span className="text-xs font-semibold uppercase tracking-[0.15em] text-white/50">{language.followUs}</span>
          <div className="flex items-center gap-5">
            {socials.map((social) => (
              <a
                key={social.label}
                href={social.href}
                target="_blank"
                rel="noreferrer"
                aria-label={social.label}
                title={social.label}
                className="text-white/70 transition hover:text-white"
              >
                {social.icon}
              </a>
            ))}
          </div>
        </div>

        {/* Copyright + protección de datos */}
        <div className="mt-7 flex flex-col items-center gap-3 border-t border-white/15 pt-6 md:flex-row md:justify-between">
          <p className="m-0 text-sm text-white/70">
            Copyright © {currentYear} Marival® Rewards by Marival® Resorts.
          </p>

          <nav className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2">
            <a href={privacyHref} target="_blank" rel="noreferrer" className="text-sm text-white/70 underline hover:text-white">
              {language.privacyPolicy}
            </a>
            <a href={cookieHref} target="_blank" rel="noreferrer" className="text-sm text-white/70 underline hover:text-white">
              {language.cookiePolicy}
            </a>
          </nav>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
